import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { Badge, Card, Modal, Button, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Block from "../../components/Block/Block";
import { Icon } from "../../components";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Pagination from "../Constant/Pagination";
import { IoLocationSharp } from "react-icons/io5";
import {
  createRouteApi,
  getRouteListApi,
} from "../../services/TransportService";
import Routemap from "./Routemap";
import { IoIosArrowForward } from "react-icons/io";
function RouteListPage({ userRole }) {
  const [data, setData] = useState([]);
  const [selectedData, setSelecteddata] = useState(null);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddSubmiting, setIsAddSubmiting] = useState(false);
  const [mapOpen, setMapopen] = useState(false);
  const handleopen = () => {
    setMapopen(true);
  };
  const handleclose = () => {
    setMapopen(false);
  };
  const [addFormFields, setAddFormFields] = useState({
    number_plate: "",
    capacity: 40,
    is_active: false,
  });
  const recordsPage = 10;
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    page: 1,
    page_size: 7,
    query: "",
    status: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const conditionalRowStyles = [
    {
      when: (row) => selectedData && row.id === selectedData?.id,
      style: {
        backgroundColor: "rgba(45, 43, 43, 0.15)", // light blue
        color: "#004085",
        fontWeight: "bold",
      },
    },
  ];
  const fetchData = useCallback(() => {
    setIsLoading(true);
    getRouteListApi(filter)
      .then((resp) => {
        setData(resp.data.results);
        setSelecteddata(resp.data.results[0]);
        setTotal(resp.data?.count || 0);
      })
      .catch((error) => {
        console.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter.page, filter.query, filter.status]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (page) => {
    setFilter((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    setFilter((prev) => ({
      ...prev,
      page: 1,
      query: value,
    }));
  };
  const handleToggleModal = () => {
    if (modalVisible) {
      setAddFormFields({
        number_plate: "",
        capacity: 40,
        is_active: false,
      });
    }
    setModalVisible((prev) => !prev);
  };
  const handleSubmit = () => {
    setIsAddSubmiting(true);
    createRouteApi(addFormFields)
      .then((resp) => {
        setData((prev) => [resp.data, ...prev]);
        setTotal((prev) => prev + 1);
        handleToggleModal();
      })
      .catch((error) => {
        console.error(error?.response?.data?.message);
      })
      .finally(() => {
        setIsAddSubmiting(false);
      });
  };
  const columns = [
    {
      name: "Route Number",
      selector: (row) => row.route_number || "N/A",
      wrap: true,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => (row?.name ? `${row.name}` : "N/A"),
      wrap: true,
      grow: "2",
    },
    {
      name: "Total distance",
      selector: (row) => `${row.total_distance} km` || "NA",
      wrap: true,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.is_active,
      cell: (row) => (
        <span
          className={`badge text-bg-${
            row.is_active ? "success-soft" : "danger-soft"
          }`}
        >
          {row.is_active ? "Active" : "Inactive"}
        </span>
      ),
      wrap: "true",
    },
    {
      name: "View",
      cell: (row) => (
        <span
          className="btn btn-sm btn-outline-info"
          onClick={() => {
            setSelecteddata(row);
            console.log(row);
            handleopen();
          }}
          // style={{
          //   backgroundColor: "#e7f3ff",
          //   color: "#007bff",
          //   padding: "4px 10px",
          //   borderRadius: "15px",
          //   fontSize: "13px",
          //   fontWeight: 500,
          //   textDecoration: "none",
          //   display: "inline-block",
          // }}
        >
          View in map
          {/* <IoLocationSharp /> */}
        </span>
      ),
      wrap: "true",
    },
    {
      name: "Action",
      cell: (row) => (
        <Link
          to={`/Route/${row.id}`}
          className="btn btn-sm btn-outline-primary d-inlie-block"
          // style={{
          //   backgroundColor: "#e7f3ff",
          //   color: "#007bff",
          //   padding: "4px 10px",
          //   borderRadius: "15px",
          //   fontSize: "13px",
          //   fontWeight: 500,
          //   textDecoration: "none",
          //   display: "inline-block",
          // }}
          // onMouseEnter={(e) => (e.target.style.backgroundColor = "#d0e7ff")}
          // onMouseLeave={(e) => (e.target.style.backgroundColor = "#e7f3ff")}
        >
          Details
          <IoIosArrowForward className="ms-1" />
        </Link>
      ),
      wrap: true,
    },
  ];
  return (
    <div>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Routes</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Routes
                </li>
              </ol>
            </nav>
          </Block.HeadContent>

          <Block.HeadContent>
            <ul className="d-flex">
              <li className="me-2">
                <DebounceSearchInput
                  handleSearchChange={handleSearchChange}
                  placeholder="Search Route.."
                />
              </li>
              <li>
                {userRole === "Admin" && (
                  <Link
                    to="/add-route"
                    className="d-md-inline-flex btn btn-primary"
                  >
                    <Icon name="plus" />
                    <span>Add Route</span>
                  </Link>
                )}
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>
      <Block>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {isLoading ? (
                <div className="my-4 text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : data.length === 0 ? (
                <div className="my-4 text-center">
                  There are no records found.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table fs-6 align-middle mb-0">
                    <thead className="custom-thead table-light">
                      <tr>
                        <th>Route Name</th>
                        <th>Route No.</th>
                        <th>Total Distance</th>
                        <th>Status</th>
                        <th>View</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((row, index) => (
                        <tr key={index}>
                          <td>{row?.name || "N/A"}</td>
                          <td>{row.route_number || "N/A"}</td>
                          <td>
                            {row?.total_distance
                              ? `${row.total_distance} km`
                              : "N/A"}
                          </td>
                          <td>
                            <span
                              className={`badge text-bg-${
                                row.is_active ? "success-soft" : "danger-soft"
                              }`}
                            >
                              {row.is_active ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-info"
                              onClick={() => {
                                setSelecteddata(row);
                                console.log(row);
                                handleopen();
                              }}
                            >
                              View in map
                            </button>
                          </td>
                          <td>
                            <Link
                              to={`/Route/${row.id}`}
                              className="btn btn-sm btn-outline-primary"
                            >
                              Details <IoIosArrowForward className="ms-1" />
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Pagination Component (if not loading and data exists) */}
              {!isLoading && data.length > 0 && (
                <div className="border-top p-4">
                  <Pagination
                    currentPage={filter.page}
                    recordsPage={filter.page_size}
                    dataLength={total}
                    handlePagination={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
          {/* <div className="col-12 col-md-5">
              {selectedData?.stop_sequences && selectedData?.polyline ? (
                <Routemap data={selectedData} />
              ) : (
                <div className="d-flex justify-content-center align-items-center gap-1 my-4">
                  <span>No data found...</span>
                </div>
              )}
            </div> */}
        </div>

        <Modal
          show={modalVisible}
          onHide={handleToggleModal}
          centered
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Create Route</Modal.Title>
          </Modal.Header>

          <Modal.Body className="py-4">
            <div className="filter-sections">
              <div className="mb-3">
                <label htmlFor="number_plate" className="form-label">
                  Registration Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="number_plate"
                  placeholder="Enter Registration Number"
                  value={addFormFields.number_plate}
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      number_plate: e.target.value.toUpperCase(),
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <label htmlFor="capacity" className="form-label">
                  Capacity
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="capacity"
                  placeholder="Enter Capacity"
                  value={addFormFields.capacity}
                  onChange={(e) =>
                    setAddFormFields({
                      ...addFormFields,
                      capacity: e.target.value,
                    })
                  }
                />
              </div>
              <div>
                <div
                  className="form-check form-check-sm"
                  style={{ fontSize: "0.8rem" }}
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={"is_active"}
                    id={"is-active"}
                    checked={addFormFields.is_active}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        is_active: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor={"is-active"}>
                    Set Active
                  </label>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="outline-secondary"
              disabled={isAddSubmiting}
              onClick={handleToggleModal}
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              disabled={isAddSubmiting}
              onClick={handleSubmit}
            >
              Create
              {isAddSubmiting && (
                <span
                  className="spinner-border spinner-border-sm ms-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Block>
      <Routemap
        id={selectedData?.id}
        open={mapOpen}
        handleclose={handleclose}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userRole: state.auth.user?.role || "Employee",
});

export default connect(mapStateToProps)(RouteListPage);
